export default {
  meta: {
    title: '门店类型配置',
    url: '/system/storetype', // 埋点用，记录所属模块
  },
};
